import React from 'react';
import './CustomFooter.css';

import Logo from './logo.png';

const CustomFooter = () => {
  return (
    <>
      <footer className="custom-footer">
        <div className="footer-content">
        <div className="footer-brand w-100 d-flex justify-content-center align-items-center ">
  <img 
    src={Logo} 
    alt="Logo" 
    className="img-fluid" 
    style={{ maxWidth: '15rem', height: 'auto', opacity: '1' }} 
  />
</div>


         <p className="footer-note">
            <i className="bi bi-c-circle copyright-icon"></i> 2025 <strong>binzal</strong>. All rights reserved.
          </p>
          
<p className="made-with d-none d-md-block">
  Crafted with <span className="heart">❤️</span> in Bangalore
</p>

 
        </div>
      </footer>

    </>
  );
};

export default CustomFooter;
